import React from "react";
import { useLocation } from "react-router-dom";
import TOCModuleSubtopic from "../TOCModuleSubtopic";

const ModuleSubtopicDFA = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <TOCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Deterministic Finite Automata (DFA) in TOC"
      videos={[
        "https://www.youtube.com/embed/HH6zFZVh9fU",
        "https://www.youtube.com/embed/EgeFoVHA-A4",
      ]}
      takeaways={[
        { text: "Understand the concept and working of DFA." },
        { text: "Learn how DFA processes input deterministically." },
      ]}
      questions={[

      ]}
      exampleVideos={[]} // Add example question videos if needed
    />
  );
}

export { ModuleSubtopicDFA };
